import dataBloedErnstigTAR from "../../../../src/data/ernstige-bloedingen-onder-tar.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataBloedErnstigTAR,
  BasicSchematic,
  React
};